<template>
    <nav aria-label="Page navigation">
        <ul class="pagination">
            <!-- Previous Button -->
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
                <a
                    class="page-link"
                    href="#"
                    aria-label="Previous"
                    @click.prevent="changePage(currentPage - 1)"
                >
                    <span aria-hidden="true">&laquo;</span>
                </a>
            </li>

            <!-- Page Numbers -->
            <li
                v-for="page in displayedPages"
                :key="page"
                class="page-item"
                :class="{ active: page === currentPage, disabled: page === '...' }"
            >
                <a
                    v-if="page !== '...'"
                    class="page-link"
                    href="#"
                    @click.prevent="changePage(page)"
                >
                    {{ page }}
                </a>
                <span v-else class="page-link">...</span>
            </li>

            <!-- Next Button -->
            <li class="page-item" :class="{ disabled: currentPage === lastPage }">
                <a
                    class="page-link"
                    href="#"
                    aria-label="Next"
                    @click.prevent="changePage(currentPage + 1)"
                >
                    <span aria-hidden="true">&raquo;</span>
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    name: 'VuePagination',

    props: {
        currentPage: {
            type: Number,
            required: true,
        },
        lastPage: {
            type: Number,
            required: true,
        },
        visiblePages: {
            type: Number,
            default: 5,
        },
    },

    computed: {
        displayedPages() {
            const pages = [];
            const half = Math.floor(this.visiblePages / 2);

            let start = Math.max(1, this.currentPage - half);
            let end = Math.min(this.lastPage, this.currentPage + half);

            // Adjust if we're near the beginning
            if (this.currentPage <= half) {
                end = Math.min(this.lastPage, this.visiblePages);
            }

            // Adjust if we're near the end
            if (this.currentPage > this.lastPage - half) {
                start = Math.max(1, this.lastPage - this.visiblePages + 1);
            }

            // Add first page and ellipsis if needed
            if (start > 1) {
                pages.push(1);
                if (start > 2) {
                    pages.push('...');
                }
            }

            // Add page numbers
            for (let i = start; i <= end; i++) {
                pages.push(i);
            }

            // Add last page and ellipsis if needed
            if (end < this.lastPage) {
                if (end < this.lastPage - 1) {
                    pages.push('...');
                }
                pages.push(this.lastPage);
            }

            return pages;
        },
    },

    methods: {
        changePage(page) {
            if (page >= 1 && page <= this.lastPage && page !== this.currentPage) {
                this.$emit('page-change', page);
            }
        },
    },
};
</script>
